module.exports = __webpack_public_path__ + "img/customerGrey.e08f4ba2.svg";